import { Component, Injector, OnInit } from '@angular/core';
import { ApplicationConstant } from '../../../application.constant';
import { counter } from '../../../shared/constant/counter.constatnt';
import { PostCjResponseResultModel } from '../../../shared/customer-jouney/post-cj-response-result';
import { LookUpMasterModel } from '../../../shared/models/lookup-master/lookup-master.model';
import { Params } from '@angular/router';
import { EmailMaskPipe, TelephoneMaskPipe } from '../../../shared/pipe/mask-pipe';
import { StartUpConfigUiService } from '../../../shared/service/ui/start-up-config-ui.service';
import { Utils } from '../../../shared/Utils/Utils';
import { BaseCJQuestion } from '../../extended-class/base-cj-question';
import { AbTestConfigModel } from '../../../shared/models/start-up-config/abtest-config-model';

@Component({
  selector: 'app-contact-detail',
  templateUrl: './contact-detail.component.html'
})
export class ContactDetailComponent extends BaseCJQuestion implements OnInit {
  public lookUpMaster = ApplicationConstant.lookMasterDetails;
  public isSubmitted = false;
  public postalCode: string;
  public isPrefilledPhone = false;
  public isPrefilledEmail = false;
  public isCheckBox = false;
  public isTelephoneQuestionEnabled = true;
  private isEmailDataModified = false;
  private isTeleDataModified = false;
  private cSig: string | null;
  private utm_source: string | null;
  private utm_campaign: string | null;
  private returnCode: string | null;
  private abTestConfig: AbTestConfigModel = ApplicationConstant.abTestConfig;

  constructor(
    serviceInjector: Injector,
    private startupConfigUiService: StartUpConfigUiService
  ) {
    super(serviceInjector);
  }

  public ngOnInit(): void {
    this.utm_source = this.activatedRoute.snapshot.queryParamMap.get('utm_source');
    this.utm_campaign = this.activatedRoute.snapshot.queryParamMap.get('utm_campaign');
    this.returnCode = this.activatedRoute.snapshot.queryParamMap.get('returncode');
    this.cSig = this.activatedRoute.snapshot.queryParamMap.get('c-sig');

    this.contractType = this.customerJourneyService.contractType;
    this.postalCode = this.contractType.postalCode;

    this.counterService.processCounterByCounterName(counter.ContactPage).subscribe();
    const sectionNumber = 2;

    this.isTelephoneQuestionEnabled = this.abTestConfig.isTelephoneQuestionEnabled;

    if (this.isTelephoneQuestionEnabled) {
      this.counterService.processCounterByCounterName(counter.TelephoneQuestion).toPromise();
    }

    const questionText = this.getAllSectionQuestionText(sectionNumber, this.isTelephoneQuestionEnabled);
    this.gtmDatalayerUiService.addVirtualPage('customerjourney', 'Q2', sectionNumber, questionText, 'default', 'V1').toPromise();
  }

  public getFilteredQuestion(questionkey: string): LookUpMasterModel {
    return this.getQuestionModelByKey(questionkey);
  }

  public prev(): void {
    this.customerJourneyService.updateContractType(this.contractType);
    this.router.navigate([Utils.getBaseRoute()], {
      relativeTo: this.activatedRoute,
      queryParamsHandling: 'merge',
      fragment: 'Q1'
    });
  }

  public saveAnswer(): void {
    this.isSubmitted = true;

    if (!this.isTelephoneQuestionEnabled) {
      this.contractType.phone = '-999';
    }

    if (this.validationUiService.isValidEmailPage(this.contractType, this.isTelephoneQuestionEnabled) && this.isCheckBox) {
      this.contractType.noOfPerson = this.contractType.policyHolder.personType.length;
      this.addGTMAnswerString();

      this.customerJourneyService.postCjData(this.contractType, this.abTestConfig).subscribe((res: PostCjResponseResultModel) => {
        if (!res.isSuccess) {
          this.startupConfigUiService.redirectToCms();
        }
        setTimeout(() => {
          let params: Params = {
            waitpagetype: 'isWaitPageCounterInserted',
            'c-sig': this.cSig,
            actid: res.caid
          };
          if (this.utm_source) {
            const utmSource = {
              utm_source: this.utm_source
            };
            params = { ...params, ...utmSource };
          }
          if (this.utm_campaign) {
            const utmCampaign = {
              utm_campaign: this.utm_campaign
            };
            params = { ...params, ...utmCampaign };
          }
          if (this.returnCode) {
            const returnCode = {
              returnCode: this.returnCode
            };
            params = { ...params, ...returnCode };
          }
          this.router.navigate(['/progress'], {
            queryParams: params
          });
        }, 500);
        this.addGTMEcomEvent(this.isTelephoneQuestionEnabled);
      });
    }
  }

  public applyEmailMask(): string {
    if (!this.isEmailDataModified && this.contractType?.emailAddress) {
      const emailMaskPipe = new EmailMaskPipe();
      return emailMaskPipe.transform(this.contractType.emailAddress);
    } else {
      return this.contractType?.emailAddress;
    }
  }

  public applyTeleMask(): any {
    if (!this.isTeleDataModified && this.contractType?.phone) {
      const telePipe = new TelephoneMaskPipe();
      return {
        isMaskedApplied: true,
        transformedData: telePipe.transform(this.contractType.phone)
      };
    } else {
      return {
        isMaskedApplied: false,
        transformedData: this.contractType?.phone
      };
    }
  }

  public isValidEmail(email: string) {
    this.validationUiService.validateEmail(email);
  }

  public getCityByPostCode(): void {
    this.contractType.postalCode = '';
    this.contractType.province = '';
    if (Utils.isNumber(this.postalCode)) {
      this.customerJourneyService.getPostalCodeDetails(this.postalCode).subscribe((result) => {
        if (result) {
          this.contractType.postalCode = result.postalCode;
          this.contractType.province = result.provinceName;
        }
      });
    }
  }

  public onKeyPress(evt: any): boolean {
    this.isTeleDataModified = true;
    return Utils.isNumber(evt);
  }

  public onEmailModelChange(modelData: string): void {
    this.isEmailDataModified = true;
    this.contractType.emailAddress = modelData;
  }

  public onTeleModelChange(modelData: string): void {
    this.isTeleDataModified = true;
    this.contractType.phone = modelData;
  }

  private addGTMAnswerString(): void {
    let gtmAnswerStr = `${this.contractType.province} - ${this.contractType.emailAddress}`;
    const phone = this.contractType.phone;
    if (this.isTelephoneQuestionEnabled) {
      gtmAnswerStr = gtmAnswerStr + '- ' + phone;
    }
    this.addGTMAnswer('Q2', gtmAnswerStr);
  }
}
